import React from 'react';
import ReactTooltip from 'react-tooltip';
import { BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const FulfillmentOrdersExpandListTemplate = ({
	fulfillmentOrdersExpandListViewStore,
	fulfillmentOrdersExpandListViewStore: { tableData, noDataItem, data, change, loading },
}) => {
	if (loading) return null;
	return (
		<section>
			<BaasicTable
				{...{
					data,
					tableData,
					fulfillmentOrdersExpandListViewStore,
					noDataItem,
					showImage: false,
					change,
				}}
				actions={fulfillmentOrdersExpandListViewStore}
			/>
			<ReactTooltip />
		</section>
	);
};

export default defaultTemplate(FulfillmentOrdersExpandListTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/FulfillmentOrdersExpandListTemplate.jsx